import React from "react";
import { Card, Accordion } from "react-bootstrap";
import { FaBuilding } from "react-icons/fa";
import { formatarTamanho } from "./utils";
import TabelaArquivos from "./TabelaArquivos";

function ArquivosPorEntidade({ porEntidade }) {
  if (!porEntidade || porEntidade.length === 0) {
    return (
      <Card>
        <Card.Header className="fw-semibold">Arquivos por entidade</Card.Header>
        <Card.Body className="p-2">
          <p className="text-muted p-2 mb-0">Nenhum arquivo encontrado.</p>
        </Card.Body>
      </Card>
    );
  }

  return (
    <Card>
      <Card.Header className="fw-semibold">Arquivos por entidade</Card.Header>
      <Card.Body className="p-2">
        <Accordion>
          {porEntidade.map((ent, idx) => {
            const totalEnt = ent.arquivos.reduce((acc, a) => acc + (a.tamanho || 0), 0);
            const qtdDocs  = ent.arquivos.filter((a) => a.tipo === "documento").length;
            const qtdAdits = ent.arquivos.filter((a) => a.tipo === "aditivo").length;
            return (
              <Accordion.Item eventKey={String(idx)} key={ent.id_entidade}>
                <Accordion.Header>
                  <FaBuilding size={13} className="me-2 text-muted" />
                  <strong className="me-3">{ent.nome}</strong>
                  <small className="text-muted me-3">
                    {ent.arquivos.length} arquivo{ent.arquivos.length !== 1 ? "s" : ""}
                  </small>
                  <small className="text-muted me-3">
                    {qtdDocs} doc · {qtdAdits} adit
                  </small>
                  <small className="text-muted">{formatarTamanho(totalEnt)}</small>
                </Accordion.Header>
                <Accordion.Body className="p-0">
                  <TabelaArquivos arquivos={ent.arquivos} />
                </Accordion.Body>
              </Accordion.Item>
            );
          })}
        </Accordion>
      </Card.Body>
    </Card>
  );
}

export default ArquivosPorEntidade;
